import { removeAccent } from '@savgroup-front-common/core/src/formatters';

export const matchesSearchQuery = (searchableValues: string[], searchQuery: string): boolean => {
  const trimmedQuery = searchQuery.trim();

  if (!trimmedQuery) {
    return true;
  }

  const normalizedQuery = removeAccent(trimmedQuery.toLowerCase());

  return searchableValues.some((value) => {
    const normalizedValue = removeAccent(value.toLowerCase());

    return normalizedValue.includes(normalizedQuery);
  });
};

export const filterItemsBySearchQuery = <T>(
  items: T[],
  searchQuery: string,
  getSearchableValues: (item: T) => string[],
): T[] => {
  const trimmedQuery = searchQuery.trim();

  if (!trimmedQuery) {
    return items;
  }

  return items.filter((item) => matchesSearchQuery(getSearchableValues(item), searchQuery));
};
